import React, { Component, Fragment } from "react";



import axios from "axios";

import { Table, Container, Row, InputGroup, Col, Navbar, NavbarBrand, Nav, NavItem, NavLink, Card, CardBody, CardTitle, CardSubtitle, CardText, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, FormGroup, Label, Input } from "reactstrap";
import moment from "moment";
import HeaderComponent from "../header/HeaderComponent";
import Select from "react-select";

import $ from "jquery";
import "datatables.net";
import { is } from "immutable";

const { Base64 } = require("js-base64");

function statusChange(type) {
  const { data } = this.state;
  this.setState({ data: data.set("currentSlamState", type) });
}

function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
class AllPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMode: "all",
      showModal: false,
      tableData: [],
      selectedData: undefined,
      max_rows: 25,
      selectedProjectName: "all",
      loading: false,
    };
    statusChange = statusChange.bind(this);
    this.mqttClient = "";
    this.test = React.createRef();
    this.modalRef = React.createRef();
    window.that = this;
  }







  toggleModal = (item) => {

    this.setState({ showModal: !this.state.showModal });
  };


  closeModal = () => {

    this.setState({ isModalOpen: false, modalImageSrc: '', isInfoModalOpen: false });
  };
  onEvalChanged = async (seq, value) => {
    const { data } = this.state;
    const result = await axios({
      method: "Post",
      url: `${this.props.urls[this.props.stage]}/admin/request`,
      data: {
        seq: seq,
        evaluation: value,
      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    alert("변경했습니다.");
    this.doShowModal(Base64.encode(JSON.stringify(result.data.data)));
  };
  onValueChanged = (name, value) => {

    console.log("name:", name, ",value:", value)

    this.setState({
      [name]: value

    }, () => {
      if (name == "selectedMode") {
        this.initializeDatatable();
      }
      if (name == "selectedProjectName") {
        this.initializeDatatable();
      }
    });

  };
  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.closeModal();
    }
  };
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  getEsmCall = async () => {

    await axios({
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/esm`,
      params: {

      },
      type: "get",
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
      error: function (xhr, error, code) {
        console.log(error);
      },
    });



  };
  getDataTableAjax = () => {
    const { data } = this.state;

    let mode = this.state.selectedMode

    if (mode == "diverged") {
      mode = "all";
    }
    return {
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/all?status=${this.state.selectedMode}`,
      type: "get",
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
      error: function (xhr, error, code) {
        if (xhr && (xhr.status === 401 || xhr.status === 403)) { alert("권한이 없습니다. 다시 로그인해 주세요."); } else { console.warn("데이터를 불러오지 못했습니다(일시적 오류). 잠시 후 새로고침해 주세요.", xhr && xhr.status); }
      },
    };
  };

  getTaskInfo = async (seq) => {



    const _result = await axios({
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/task/info`,
      params: {
        seq: seq,
      },
      type: "get",
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
      error: function (xhr, error, code) {
        if (xhr && (xhr.status === 401 || xhr.status === 403)) { alert("권한이 없습니다. 다시 로그인해 주세요."); } else { console.warn("데이터를 불러오지 못했습니다(일시적 오류). 잠시 후 새로고침해 주세요.", xhr && xhr.status); }
      },
    });
    const result = JSON.parse(_result.data.body);
    this.setState({
      currentTask: result.task,
      currentEnvParm: result.parmenv,
      isInfoModalOpen: true,
    })
  };
  projectCheck = (project_name, type) => {

    if (type === "all") {
      window.open("/product?project_name=" + project_name, "_blank");
    } else if (type === "list") {
      window.open("/productall?project_name=" + project_name, "_blank");
    }
    else {
      window.open("/productone?project_name=" + project_name, "_blank");
    }
  }
  getColumnSetting = () => {




    let idx = { title: "idx", data: "idx", searchable: true, className: "dt-center", width: "5%" };

    let project_name = { title: "project_name", data: "project_name", searchable: true, className: "dt-center", width: "15%" };

    // let status = { title: "status", data: "status", className: "dt-center", width: "5%" };
    let total_products = { title: "총 프로덕트 숫자", data: "total_products", className: "dt-center", width: "10%" };
    let accept_count = {
      title: "1차 통과 숫자", data: "accept_count", className: "dt-center", width: "5%",

      render: function (data, type, row, meta) {
        if (row.check_status != "accept" && row.check_status != "completed") {
          return "-"
        }
        return data;
      }

    };
    let fail_count = {
      title: "1차 실패 숫자", data: "fail_count", className: "dt-center", width: "5%",

      render: function (data, type, row, meta) {
        if (row.check_status != "accept" && row.check_status != "completed") {
          return "-"
        }
        return data;
      }

    };
    let customer_accept_count = {
      title: "2차 통과 숫자", data: "customer_accept_count", className: "dt-center", width: "5%",
      render: function (data, type, row, meta) {
        if (row.check_status != "accept" && row.check_status != "completed") {
          return "-"
        }
        return data;
      }
    };
    let customer_reject_count = {
      title: "2차 제외 숫자", data: "customer_reject_count", className: "dt-center", width: "5%",
      render: function (data, type, row, meta) {
        if (row.check_status != "accept" && row.check_status != "completed") {
          return "-"
        }
        return data;
      }
    };
    let customer_ready_count = {
      title: "2차 준비 숫자", data: "customer_ready_count", className: "dt-center", width: "5%",
      render: function (data, type, row, meta) {
        if (row.check_status != "accept" && row.check_status != "completed") {
          return "-"
        }
        return data;
      }
    };
    // let accept_count = { title: "1차 통과 숫자", data: "accept_count", className: "dt-center", width: "10%" };
    // let hold_count = { title: "1차 보류 숫자", data: "hold_count", className: "dt-center", width: "10%" };



    let status = {
      title: "상태",
      data: "check_status",
      className: "dt-center",
      width: "15%",
      render: function (data, type, row, meta) {
        if (data == "accept") {
          return `<a style="color:green; font-weight:bold">${"1차 검수 완료(차란 검수 대기)"}</a>`;
        }
        if (data == "completed") {

          return `<a style="color:orange; font-weight:bold">${"완료"}</a>`;

        }
        // 하드닝: projects.check_status 가 stale('created')로 남아도, 고객 2차검수가
        // 전부 판정(ready=0, accept+reject>0)됐으면 "완료"로 표기(라벨 불일치 방지).
        if (Number(row.customer_ready_count) === 0 &&
            (Number(row.customer_accept_count) + Number(row.customer_reject_count)) > 0) {
          return `<a style="color:orange; font-weight:bold">${"완료"}</a>`;
        }
        else {
          return `<a style="color:blue; font-weight:bold">${"1차 검수 중"}</a>`;
        }
      },
    };
    let created_datetime = {
      title: "요청 생성시간",
      data: "created_datetime",
      className: "dt-center",
      width: "10%",
      render: function (data, type, row, meta) {
        return moment(data).format("YY-MM-DD HH:mm:ss");
      },
    };

    let output_view = {
      title: "결과보기",
      data: "seq",
      className: "dt-center",
      render: function (data, type, row, meta) {

        if (row.check_status == "accept") {
          let res = `<button class="btn btn-primary btn-sm" size="sm"  onclick="window.that.projectCheck('${row.project_name}','all')" >전체검수</button>
					
						<button class="btn btn-success btn-sm" size="sm"  onclick="window.that.projectCheck('${row.project_name}','one')" >개별검수</button>
						<button class="btn btn-primary btn-sm" size="sm"  onclick="window.that.projectCheck('${row.project_name}','list')" >목록</button>
						`;
          return res;
        }
        else if (row.check_status == "completed") {
          let res = `<button class="btn btn-primary btn-sm" size="sm"  onclick="window.that.projectCheck('${row.project_name}','list')" >목록</button>
`
          return res;
        }
        else {
          let res = `1차 검수 진행중`;
          return res;
        }



      },
    };


    let arr = [idx, project_name, created_datetime, status, total_products, fail_count, accept_count,
      customer_accept_count,
      customer_reject_count,
      customer_ready_count,

      output_view];





    return arr;
  };
  initializeDatatable = () => {
    const that = this;
    const { data } = this.state;
    if (this.oTable) {
      this.oTable.destroy();
      this.test.current.innerHTML = "";
    }
    this.setState({ loading: true });
    this.oTable = $(this.test.current).DataTable({
      order: [[0, "desc"]],
      iDisplayLength: this.state.max_rows,
      searching: true,
      processing: false,
      responsive: true,
      serverSide: true,
      ajax: {
        ...this.getDataTableAjax(),
        complete: () => {
          that.setState({ loading: false });
        },
      },
      columns: this.getColumnSetting(),
      initComplete: function () {
        $(".dataTables_filter input").unbind();
        $(".dataTables_filter input").bind("keyup", function (e) {
          var code = e.keyCode || e.which;
          if (code == 13) {
            that.oTable.search(this.value).draw();
          }
        });
      },
    });
    $(".dataTables_wrapper").css("width", "100%");
    $(this.test.current).on('preXhr.dt', () => {
      that.setState({ loading: true });
    });
    $("#DataTables_Table_0_length").on("change", function (val) {
      that.setState({ data: data.set("max_rows", parseInt($("#DataTables_Table_0_length  option:selected").text())) });
    });
  };
  refreashTable = (event) => {
    this.initializeDatatable();
  };
  async componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.initializeDatatable();

  }
  getModeKor = () => {

    return "전체 목록"
  };


  handleResultClick = (project_name, seq, type) => {
    let url = "";
    if (type == "input") {
      url = this.generateImageUrl(project_name, seq);
    } else if (type == "model") {
      url = this.generateModelUrl(project_name, seq);
    } else if (type == "output") {
      url = this.generateResultUrl(project_name, seq);
    }

    this.setState({ isModalOpen: true, modalImageSrc: url });

  };
  generateImageUrl(project_name, seq) {

    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${project_name}&seq=${seq}&type=input`
  }

  generateModelUrl(project_name, seq) {

    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${project_name}&seq=${seq}&type=model`
  }

  generateResultUrl(project_name, seq) {

    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${project_name}&seq=${seq}&type=output`
  }

  render() {
    const selectedData = this.state.currentTask;


    //<TableBox options={options} sizeClass={"col-md-6"}></TableBox>
    return (
      <Fragment>
        {this.state.isModalOpen && (
          <div className="modals">
            <div className="modal-contents" style={{ "overflow-y": "scroll", alignContent: "center" }} ref={this.modalRef}>
              <img style={{
                display: "block",
                "margin-left": "auto",
                "margin-right": "auto",
                "object-fit": "contain",
                "max-height": 800
              }} src={this.state.modalImageSrc} alt="Large version" className="modal-image" />
            </div>
          </div>)}
        {this.state.isInfoModalOpen && (
          <div className="modals">
            <div className="modal-contents" style={{ "overflow-y": "scroll", height: 500 }} ref={this.modalRef}>

              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>

                <button className="close-btn" onClick={() => this.closeModal(null)}>
                  X
                </button>
                <Col md={11}>
                  <table style={{ width: "100%", border: "1px solid black", "border-collapse": "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>Prop</th>
                        <th style={{ width: "50%" }}>Value</th>
                      </tr>
                    </thead>
                    <tbody>

                      <tr>
                        <td className="tb_td">idx</td>
                        <td className="tb_td">{selectedData.idx}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">seq</td>
                        <td className="tb_td">{selectedData.seq}</td>
                      </tr>

                      <tr>
                        <td className="tb_td">설명 프롬프트 (옛·미사용)</td>
                        <td className="tb_td">{this.state.currentEnvParm.prompt_1}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">베이스 프롬프트 (옛·미사용)</td>
                        <td>{this.state.currentEnvParm.prompt_2}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">생성 프롬프트 (nano)</td>
                        <td className="tb_td">{selectedData.image_prompt}</td>
                      </tr>

                    </tbody>
                  </table>
                </Col>



              </div>

            </div>
          </div>)}
        <HeaderComponent signOut={this.props.cognito.signOut} setStage={this.props.setStage} stage={this.props.stage}></HeaderComponent>
        <div className="main_contents">
          <Container fluid>
            <Row>
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                <Col md={4}>


                </Col>

                <Col md={4} style={{ alignItems: "center", display: "flex", fontSize: 25, color: "black", fontWeight: 800, justifyContent: "center" }}>
                  {this.getModeKor()}
                </Col>

                <Col md={4}>

                  <Col md={4}>
                    <ButtonGroup>
                      <Button
                        color="info"
                        onClick={() => {
                          this.initializeDatatable();
                        }}
                      >
                        Refresh
                      </Button>
                    </ButtonGroup>
                  </Col>
                  <Col md={4}>

                  </Col>

                  <Col md={4}>
                    <Input value={this.state.selectedMode} onChange={(e) => this.onValueChanged("selectedMode", e.target.value)} id="selectedMode" name="selectedMode" type="select">
                      <option value={"all"}>목록 선택(전체보기)</option>
                      <option value={"accept"}>1차 검수 완료</option>
                      <option value={"created"}>1차 검수 중</option>
                      <option value={"completed"}>완료</option>



                    </Input>
                  </Col>
                </Col>
              </div>
              {this.state.loading && (
                <div style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  padding: '24px 0', gap: 12,
                }}>
                  <div style={{
                    width: 28, height: 28,
                    border: '3px solid #e0e0e0',
                    borderTop: '3px solid #4a90d9',
                    borderRadius: '50%',
                    animation: 'dt-spin 0.8s linear infinite',
                  }} />
                  <span style={{ fontSize: 15, fontWeight: 600, color: '#4a90d9', letterSpacing: 1 }}>
                    데이터 로딩 중...
                  </span>
                  <style>{`@keyframes dt-spin { to { transform: rotate(360deg); } }`}</style>
                </div>
              )}
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                <Table bordered style={{ width: "100%" }} innerRef={this.test} />
              </div>
            </Row>
          </Container>
        </div>
      </Fragment>
    );
  }
}

export default AllPage;
